<template>
  <el-container>
    <el-aside id="my-el-aside" class="my-el-aside" width="200px" style="
      border-bottom: solid 1px #e6e6e6;">
      <el-menu
        default-active="/admin/home"
        class="el-menu-vertical-demo"
        :router="true">
        <el-menu-item index="/admin/home">
          <i class="el-icon-menu"></i>
          <span slot="title">后台首页</span>
        </el-menu-item>
        <el-menu-item index="/admin/blogManager">
          <i class="el-icon-document"></i>
          <span slot="title">博客管理</span>
        </el-menu-item>
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-s-custom"></i>
            <span>用户管理</span>
          </template>
          <el-menu-item-group>
            <template slot="title">用户组</template>
            <el-menu-item index="/admin/userManager"><i class="el-icon-user-solid"></i>普通用户</el-menu-item>
            <el-menu-item index="/admin/adminManager"><i class="el-icon-user"></i>管理员用户</el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <el-menu-item index="/admin/inputBlog">
          <i class="el-icon-edit-outline"></i>
          <span slot="title">撰写博客</span>
        </el-menu-item>
        <el-menu-item index="/admin/categoryManager">
          <i class="el-icon-document-copy"></i>
          <span slot="title">分类管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/essayManager">
          <i class="el-icon-edit"></i>
          <span slot="title">笔记管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/projectManager">
          <i class="el-icon-suitcase-1"></i>
          <span slot="title">项目管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/leaveMsg">
          <i class="el-icon-chat-round"></i>
          <span slot="title">留言管理</span>
        </el-menu-item>
        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-mobile"></i>
            <span>个人中心</span>
          </template>
          <el-menu-item-group>
            <template slot="title">资料</template>
            <el-menu-item index="/admin/skill"><i class="icon-jineng font-size-14 iconfont"></i>技能</el-menu-item>
            <el-menu-item index="/admin/hobby"><i class="icon-xingquaihao  font-size-14 iconfont"></i>爱好</el-menu-item>
            <el-menu-item index="/admin/assess"><i class="icon-ziwopingjia  font-size-14 iconfont"></i>自我评价
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-main id="my-el-main">
      <el-header class="my-el-header">
        <div style="display: flex">
          <span style="font-size: 16px;display: flex;text-align:left;margin-left: 20px">
            <span class="hidden-xs-only">欢迎</span>
            <span class="hidden-xs-only" style="color: red;margin-left: 5px">{{ adminUser.adminName }}</span>
          </span>
          <span style="display: flex;margin: 0 auto">博 客 后 台 管 理</span>
          <div style="text-align: right;margin-right: 20px">
            <img class="hidden-xs-only" style="margin-top: 4px;border-radius: 50%;border: 1px solid rgba(0,0,0,0.57);"
                 :src="adminUser.headPortrait"
                 width="50" height="50">
          </div>
        </div>
      </el-header>
      <el-main>
        <router-view></router-view>
        <el-backtop :visibility-height="100" style="z-index: 99999">
          <div class="my-el-backtop-icon">
            <i class="el-icon-caret-top"></i>
          </div>
        </el-backtop>
      </el-main>
    </el-main>

  </el-container>

</template>
<script>

import base_url from "../../utils/Constants";

export default {
  data() {
    return {
      adminUser: {
        adminName: '',
        headPortrait: ''
      }
    }
  },
  methods: {
    //当页面调整大小的时候
    changeWidth() {
      let myElHeader = document.getElementById("my-el-main");
      let myElAside = document.getElementById("my-el-aside");
      myElHeader.style.width = document.documentElement.clientWidth - (myElAside.clientWidth + 1) + "px";
    },
  },
  mounted() {
    /*处理页面大小适配*/
    this.changeWidth();
    let that = this;

    window.onscroll = function () {
      that.changeWidth();
    }
    window.onresize = function () {
      that.changeWidth();
    };

    //得到adminInfo对象
    let user = JSON.parse(window.sessionStorage.getItem("adminInfo"));
    this.adminUser.adminName = user.adminName;
    this.adminUser.headPortrait = base_url + "/getImage/" + user.headPortraitUrl;
    window.sessionStorage.getItem("user");
  }
}
</script>

<style>
#my-el-main {
  padding: 0;
  position: absolute;
  left: 200px;
  width: 100%;
  background-color: rgb(240, 242, 245)
}

.my-el-header {
  background-color: rgb(255, 255, 255);
  line-height: 60px;
  font-size: 28px;
  padding: 0;
}

.my-el-backtop-icon {
  height: 100%;
  width: 100%;
  background-color: #f2f5f6;
  box-shadow: 0 0 6px rgba(0, 0, 0, .12);
  text-align: center;
  line-height: 40px;
  color: #1989fa;
}

.my-el-backtop-icon:hover {
  box-shadow: 0 0 6px rgba(0, 0, 0, .30);
}
</style>

<style>
.my-el-aside ul {
  background-color: transparent;
}

.my-el-aside {
  border-bottom: none !important;
}
</style>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/AdminIndex.vue